import {
  ChangeDetectionStrategy,
  Component,
  ElementRef, inject,
  input, OnDestroy, OnInit
} from '@angular/core';
import {Logger} from '@shared/utils/logger';
import {openAuthModalAsPage, openResetPasswordAs, openRegisterAs, setAuthModalHost} from '@itc';

@Component({
  selector: 'app-itc-auth-page',
  imports: [],
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItcAuthPage implements OnInit, OnDestroy {
  private hostEl = inject(ElementRef<HTMLElement>);
  type = input<TAuthModal>('login');


  ngOnInit() {
    setAuthModalHost(this.hostEl?.nativeElement);

    switch (this.type()) {
      case 'login': openAuthModalAsPage(); break;
      case 'register': openRegisterAs(true); break;
      case 'reset-password': openResetPasswordAs(true); break;
      default: {
        Logger.error('Unknown auth type', this.type());
      }

    }
  }

  ngOnDestroy(): void {
    if (this.hostEl) {
      this.hostEl.nativeElement.innerHTML = '';
    }
  }
}

export type TAuthModal = 'login' | 'register' | 'reset-password';
